import React, { useState, useEffect } from "react";

// material-ui
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import DisplayExport from "../../../components/Exports/DisplayExport";
import TableOfViewAgencies from "./components/TableOfViewAgencies";
import SearchBar from "./components/SearchBar";
import { Get_limited_From_MongoDB } from "../../../api/Get_limited_From_MongoDB";
import { StaffuseAuth } from "../../../security/StaffuseAuth";

function ViewAgencies() {
  const { logout } = StaffuseAuth();
  //-----------------------------Get Data---------------------------------------------

  // Assuming you have a state to store the fetched data
  const [Agencies, setAgencies] = useState([]);
  //The below is the useEffect to fetch data from the backend
  useEffect(() => {
    Get_limited_From_MongoDB("IP", "Agencies", 50, setAgencies, logout);
  }, []);

  //-----------------------------Flatten Data For Export--------------------------------------------

  function deepFlattenToObject(obj, prefix = "") {
    return Object.keys(obj).reduce((acc, k) => {
      const pre = prefix.length ? prefix + "_" : "";
      if (typeof obj[k] === "object" && obj[k] !== null) {
        Object.assign(acc, deepFlattenToObject(obj[k], pre + k));
      } else {
        acc[pre + k] = obj[k];
      }
      return acc;
    }, {});
  }
  let FlattenedData = Agencies.map((Obj_Agency) => {
    return deepFlattenToObject(Obj_Agency);
  });
  //-----------------------------Components--------------------------------------------

  function GoToAddAgencies() {
    //This is the flex item
    return (
      <Box
        component="main"
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          maxWidth: "10%",
          maxHeight: "800px",
          flexGrow: 1,
          p: 1,
        }}
      >
        <div style={{ height: "44px" }}></div>
        <Link to="/Staff/ViewAgency/AddAgency">
          <button>Add Agency</button>
        </Link>
      </Box>
    );
  }

  //-----------------------------Return--------------------------------------------

  return (
    <div style={{ backgroundColor: "#e5e5e5", minHeight: "93vh" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row", // Add this line
          flexWrap: "wrap",
          justifyContent: "flex-start",
          // gap: "20px",
          // height: "100%",
        }}
      >
        <div
          name="space"
          style={{ width: "100%", height: "10px", flex: "0 1 auto" }}
        ></div>
        <SearchBar setAgencies={setAgencies} />
        <DisplayExport excelData={FlattenedData} fileName="Agencies_Data" />
        <GoToAddAgencies />
        <TableOfViewAgencies Agencies={Agencies} />
      </div>
    </div>
  );
}

export default ViewAgencies;
